import { __rest } from 'tslib';
import { jsx, Fragment } from 'react/jsx-runtime';
import { useState, useEffect, useContext, createContext } from 'react';
import { logger } from '@ninja/utilities';
import { PagePermissionCheck } from './PagePermissionCheck2.js';
import { useRouter } from './useRouter2.js';
import { LinkFactory } from './NinjaNextNavigationFactory3.js';
import { useWebNavigationUtility } from './NinjaNextNavigationFactory4.js';

class NinjaNextNavigationFactory {
    constructor(params) {
        this.Provider = (_a) => {
            var { children } = _a, props = __rest(_a, ["children"]);
            const [navigatingUrl, setNavigatingUrl] = useState();
            const router = useRouter(this.router);
            const routeInProgressHandler = (url) => {
                setNavigatingUrl(url);
            };
            const routeInProgressCompleted = () => {
                setNavigatingUrl(undefined);
            };
            useEffect(() => {
                logger.log('[NinjaNextNavigationFactory][useEffect]');
                if ('events' in router) {
                    router.events.on('routeChangeStart', routeInProgressHandler);
                    router.events.on('routeChangeComplete', routeInProgressCompleted);
                }
                return () => {
                    if ('events' in router) {
                        router.events.off('routeChangeStart', routeInProgressHandler);
                        router.events.off('routeChangeComplete', routeInProgressCompleted);
                    }
                };
            }, []);
            return (jsx(this.context.Provider, { value: Object.assign(Object.assign({}, props), { navigatingUrl }), children: children }));
        };
        this.useWebNavigation = () => {
            const contextData = useContext(this.context);
            return useWebNavigationUtility(contextData, this.routesPermissions, this.basePermissionLevels, contextData.navigatingUrl, this.router);
        };
        this.PagePermissionGate = ({ children }) => {
            const contextData = useContext(this.context);
            const noPermissionDefault = jsx(Fragment, { children: "No Permission" });
            const noAccessDefault = jsx(Fragment, { children: "No Access" });
            const { CheckIfUserHasPermissionOnCurrentPage, CheckIfCurrentPageIsNotLoggedInOnly, CheckIfUserHasAccessOnCurrentPage, } = useWebNavigationUtility(contextData, this.routesPermissions, this.basePermissionLevels, contextData.navigatingUrl, this.router);
            const { isLoggedInUser, noPermissionComponent, onRedirectToLogin, onRedirectLoggedInUser, noAccessComponent } = contextData;
            const isUserHasPermissionOnCurrentPage = CheckIfUserHasPermissionOnCurrentPage();
            const isUserHasAccessOnCurrentPage = CheckIfUserHasAccessOnCurrentPage();
            return (jsx(PagePermissionCheck, { noPermissionComponent: noPermissionComponent !== null && noPermissionComponent !== void 0 ? noPermissionComponent : noPermissionDefault, isLoggedInUser: isLoggedInUser, isUserHasPermissionOnCurrentPage: isUserHasPermissionOnCurrentPage, isUserHasAccessOnCurrentPage: isUserHasAccessOnCurrentPage, noAccessComponent: noAccessComponent !== null && noAccessComponent !== void 0 ? noAccessComponent : noAccessDefault, onRedirectToLogin: onRedirectToLogin, onRedirectLoggedInUser: onRedirectLoggedInUser, CheckIfCurrentPageIsNotLoggedInOnly: CheckIfCurrentPageIsNotLoggedInOnly, children: children }));
        };
        this.useCheckForPermission = () => {
            const { currentUserActions } = useContext(this.context);
            const superAdminPermissionLevel = this.basePermissionLevels.superAdmin;
            const isUserHasPermission = (actionName) => (currentUserActions === null || currentUserActions === void 0 ? void 0 : currentUserActions.findIndex((action) => action === superAdminPermissionLevel || action === actionName)) !== -1;
            return { isUserHasPermission };
        };
        const { routesPermissions, basePermissionLevels, router = 'pages' } = params;
        this.routesPermissions = routesPermissions;
        this.basePermissionLevels = basePermissionLevels;
        this.context = createContext({
            currentUserActions: [],
            isLoggedInUser: false,
            navigatingUrl: '',
        });
        this.context.displayName = 'NinjaNavigationContext';
        this.router = router;
    }
    get NinjaNextLink() {
        return LinkFactory(this.routesPermissions);
    }
}

export { NinjaNextNavigationFactory };
